import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import { useLang } from '~/hooks/useLang';

export default function SignatureForm() {
  const { translate } = useLang();
  return (
    <Container fixed={false} style={{ width: '100%', marginTop: '300px' }}>
      <Grid container xs={12} sx={{ width: '100%', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: "32px 24px 0" }}>
          <Typography sx={{ borderTop: 1, width: '70%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {translate('Commander')}
          </Typography>
        </Grid>
      </Grid>
    </Container>
  )
}